<div class="club-geography" :aria-busy="loading">
  <div class="club-geography__map">
  <div ref="canvas" class="club-geography__canvas" :aria-label="$t('geography.title')"></div>
  <div v-if="!ready || error" class="club-geography__state" role="status">
    <i class="bi bi-map" aria-hidden="true"></i>
    <span>{{ $t(!configured ? 'geography.unavailable' : error ? 'geography.error' : empty ? 'geography.empty' : 'geography.loading') }}</span>
    <button v-if="error" type="button" class="app-button-secondary app-button--compact" @click="load">{{ $t('common.retry') }}</button>
  </div>
  <aside v-if="point" class="club-geography__details">
    <PublicClubCard :club="selectedClub" :place="point.kind === 'place' ? point : null" :show-stats="false" show-action>
    <template #header>
    <div v-if="selected.length > 1" class="d-flex align-items-center gap-2">
      <button class="app-icon-button" type="button" :disabled="selectedIndex === 0" :aria-label="$t('geography.previous')" @click="selectedIndex--"><i class="bi bi-chevron-left"></i></button>
      <span>{{ selectedIndex + 1 }} / {{ selected.length }}</span>
      <button class="app-icon-button" type="button" :disabled="selectedIndex === selected.length - 1" :aria-label="$t('geography.next')" @click="selectedIndex++"><i class="bi bi-chevron-right"></i></button>
    </div>
      <button type="button" class="app-icon-button club-geography__close ms-auto" :aria-label="$t('common.close')" @click="selected = []"><i class="bi bi-x-lg"></i></button>
    </template>
    </PublicClubCard>
  </aside>
  </div>
  <aside v-if="cities.length" class="homepage-map__panel club-geography__cities">
    <h3>{{ $t('home.activeCities') }}</h3>
    <div v-for="city in cities" :key="city.id">
      <strong><router-link :to="{ name: 'PublicSearch', query: { q: city.name } }">{{ city.name }}</router-link></strong>
      <span>{{ $t('clubs.clubCount', city.clubs) }}</span>
      <span>{{ $t('clubs.tournamentsCount', city.tournaments) }}</span>
    </div>
    <router-link :to="{ name: 'AllClubs' }">{{ $t('home.allCities') }} <i class="bi bi-arrow-right"></i></router-link>
  </aside>
</div>
